import { useContext, useState } from "react";
import styles from "./loginForm.module.css";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Spin } from "antd";

import { useDispatch } from "react-redux";
import { login } from "../../redux/authSlice";
import { LangContext } from "../../App";
import API from "../../api/axiosInstance";
import { getUser } from "../../services/userAuth";
import axios from "axios";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await axios.post(
        "https://server.mesallah.com/auth/login",
        user
      );
      const { access_token, refresh_token } = res.data;
      localStorage.setItem("accessToken", access_token);
      localStorage.setItem("refreshToken", refresh_token);

      const userobj = await getUser();

      dispatch(login({ user: userobj.user, token: access_token }));

      if (userobj.user.role === "reseller") {
        navigate("/dashboard", { replace: true });
      } else if (
        userobj.user.role === "admin" ||
        userobj.user.role === "moderator"
      ) {
        navigate("/adminDashboard", { replace: true });
      }
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      } else {
        setError("An error occurred during login.");
      }
      console.error("Login error:", error); // Log the error for debugging purposes
    } finally {
      setLoading(false);
    }
  };

  const { lang } = useContext(LangContext);

  return (
    <div className={styles.container} dir={`${lang === "ar" ? "rtl" : "ltr"}`}>
      <form className={styles.form}>
        <h1>{t("adminPanel")}</h1>
        <input
          id="email"
          type="text"
          value={user.email}
          onChange={(e) => setUser({ ...user, email: e.target.value })}
          placeholder="email"
        />
        <input
          id="password"
          type="password"
          value={user.password}
          onChange={(e) => setUser({ ...user, password: e.target.value })}
          placeholder="password"
        />
        {loading ? <Spin /> : <button onClick={handleLogin}>Login</button>}
        {error && <p className="text-red-600">{error}</p>}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Link
            to="/register"
            style={{ padding: "10px", borderRadius: "10px" }}
          >
            {t("Register")}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
